import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ExternalLink, FileSpreadsheet } from "lucide-react";

export default function PackContents() {
  const [breaks, setBreaks] = useState(null);
  useEffect(() => {
    api.get("/pack-breaks").then((r) => setBreaks(r.data)).catch(() => setBreaks([]));
  }, []);

  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-16">
      <div className="max-w-3xl">
        <div className="text-label text-zinc-500">Transparency</div>
        <h1 className="font-display text-5xl sm:text-7xl mt-2">Mystery Pack Contents</h1>
        <p className="text-zinc-300 text-lg mt-4">
          Every case break we run comes with a full contents list. Below is the checklist for each series — click through to view the exact card list in Google Sheets.
        </p>
      </div>

      {breaks === null ? (
        <div className="mt-12 text-zinc-500">Loading…</div>
      ) : breaks.length === 0 ? (
        <div className="mt-12 border border-dashed border-white/10 rounded p-16 text-center text-zinc-500">
          <p>No break checklists posted yet. Check back after our next Whatnot show.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4 mt-12" data-testid="breaks-grid">
          {breaks.map((b) => {
            const inner = (
              <div className="p-5 flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-display text-2xl group-hover:text-[var(--cl-orange)] transition-colors line-clamp-2">
                    {b.title}
                  </h3>
                  {b.sheets_url && <ExternalLink size={16} className="text-zinc-500 flex-shrink-0 mt-1" />}
                </div>
                {b.description && <p className="text-sm text-zinc-400 mt-2 line-clamp-3">{b.description}</p>}
                {b.sheets_url && (
                  <div className="mt-4 inline-flex items-center gap-2 text-xs text-[var(--cl-orange)]">
                    <FileSpreadsheet size={12} /> Open checklist
                  </div>
                )}
              </div>
            );
            const image = b.image_url ? <img src={b.image_url} alt="" className="w-32 h-32 object-cover flex-shrink-0" /> : null;
            const cls = "group border border-white/10 rounded-md bg-[var(--cl-surface)] overflow-hidden card-hover flex";
            return b.sheets_url ? (
              <a key={b.id} href={b.sheets_url} target="_blank" rel="noreferrer" data-testid={`break-${b.id}`} className={cls}>
                {image}{inner}
              </a>
            ) : (
              <div key={b.id} data-testid={`break-${b.id}`} className={cls}>
                {image}{inner}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
